<template>
  <div>
    <list-teams
      ref="list"
      @create="create()"
      @update="update"
      @remove="remove"
      @view="view"
      :filter-entity="filterEntity"
    />
    <form-manager
      @close="close()"
      :modal="modal"
      :external-action="action"
      :Edit="edit"
      :external-team="team"
    ></form-manager>
  </div>
</template>

<script>
import listTeams from './list'
import formManager from './formManager'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'teams',
  components: {
    listTeams,
    formManager
  },
  props: {
    filterEntity: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    }
  },
  data() {
    return {
      modal: false,
      action: 'create',
      edit: true
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      team: state => state.teams.teamSelected,
      entity: state => state.teams.entitySelect,
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      getOne: 'teams/setOne',
      init: 'teams/setInit',
      setClearOne: 'teams/setClearOne',
      initCategories: 'categories/setInit',
      initEntities: 'entities/setInitSelect',
      setStatus: 'events/setStatus'
    }),
    close() {
      this.nextTick(_ => {
        this.modal = false
        this.action = ''
        this.$refs.list.status = false
      })
    },
    create() {
      this.nextTick(_ => {
        this.action = 'create'
        this.edit = true
        this.modal = true
      })
    },
    update(item) {
      this.setClearOne()
      this.getOne(item).then(_ => {
        this.nextTick(_ => {
          this.action = 'update'
          this.edit = true
          this.modal = true
        })
      })
    },
    remove(item) {
      this.setClearOne()
      this.getOne(item).then(_ => {
        this.nextTick(_ => {
          this.action = 'remove'
          this.edit = false
          this.modal = true
        })
      })
    },
    view(item) {
      this.setClearOne()
      this.getOne(item).then(_ => {
        this.nextTick(_ => {
          this.action = 'view'
          this.modal = true
          this.edit = false
        })
      })
    },
    async initData() {
      await Promise.all([
        this.init(),
        this.initCategories(),
        this.initEntities()
      ])
    }
  },
  watch: {
    statusOfButton: function(val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>
